"use client";

import Link from "next/link";
import { Coins } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

/**
 * What /pricing shows inside the iOS app. Credits are digital goods, so the
 * app can't sell them (Apple 3.1.1) — and outside the US storefront it may
 * not point at anywhere that does, so this says only that, neutrally.
 */
export function NotInApp() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-md space-y-4 py-12 text-center">
      <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
        <Coins className="h-6 w-6" />
      </span>
      <p className="text-sm text-muted-foreground">{t("pricing.notInApp")}</p>
      <Link href="/">
        <Button variant="outline" size="sm">
          {t("bottomNav.home")}
        </Button>
      </Link>
    </div>
  );
}
